export type TabId =
  | "customers"
  | "orders"
  | "carts"
  | "checkouts"
  | "fulfillments";

export enum StoreType {
  TRADITIONAL = "TRADITIONAL",
  CUSTOM = "CUSTOM",
}

export type CustomEventTopic = "login" | "logout" | "productView";

export type WebhookTopic =
  | "customers/create"
  | "customers/update"
  | "customer.tags_added"
  | "customer.tags_removed"
  | "orders/create"
  | "orders/updated"
  | "carts/create"
  | "carts/update"
  | "checkouts/create"
  | "checkouts/update"
  | "fulfillments/create"
  | "fulfillments/update"
  | "customers/purchasing_summary"
  | "customers_email_marketing_consent/update"
  | "customers_marketing_consent/update"
  | "customers/disable"
  | "customers/enable"
  | "customers/redact"
  | "draft_orders/create"
  | "draft_orders/update"
  | "orders/cancelled"
  | "refunds/create"
  | "fulfillment_events/create";

export interface EventDef {
  key: string;
  /** Friendly label in the UI */
  label: string;
  /** Helper text for the event */
  help?: string;
  /** One or more webhook topics this event maps to */
  topics: WebhookTopic[];
  /** mapping name in Iterable */
  iterableFieldName?: string;
}

export interface TabDef {
  id: TabId;
  title: string;
  description: string; // shows as tab-level helptext
  events: EventDef[];
}

export interface StatusMapping {
  status: string;
  event: string;
}

export interface ClientSideEventDef {
  key: string;
  /** Friendly label in the UI */
  label: string;
  /** Helper text for the event */
  help: string;
}
